import React from 'react';

const AssetManagement = () => {
  return (
    <div>
      <h1>Asset Management</h1>
    </div>
  );
};

export default AssetManagement; 